export const LOCALSTORAGE_AGECHECK = 'ageCheck';
